import PropTypes from 'prop-types';
import { useImage } from 'react-image';
import classNames from 'classnames';

export function Image({
  src,
  alt,
  className,
  ...props
}) {
  const { src: selectedSrc } = useImage({
    srcList: [src, import.meta.env.NX_DEFAULT_IMAGE]
  });
  return (
    <img
      src={selectedSrc}
      alt={alt}
      className={classNames('object-fit-cover', className)}
      {...props}
    />
  );
}

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  ...useImage.propTypes
};

export default Image;
